module.exports = __webpack_public_path__ + "static/media/rock_lose.4aea4af0.png";